import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Container, Paper, Typography } from "@material-ui/core";

import MainTitle from "components/MainTitle";
import { useUsers, useNotifications } from "hooks";
import MetaTags from "components/MetaTags";

import useStyles from "./useStyles";

const AccountLayout = (props) => {
  const { children, backLink, title } = props;
  const classes = useStyles();
  const { addErrorNotification } = useNotifications();
  const { errors, clearErrors } = useUsers();

  useEffect(() => {
    if (errors) {
      addErrorNotification();
      clearErrors();
    }
  }, [errors]);

  return (
    <>
      <div className={classes.root}>
        <Container className={classes.content}>
          <Typography align="center" variant="h1" className={classes.title}>
            My Account
          </Typography>
          <Paper classes={{ root: classes.paper }}>{children}</Paper>

          {backLink && (
            <NavLink exact className={classes.backBtn} to={backLink}>
              Back
            </NavLink>
          )}
        </Container>
      </div>
      <MainTitle title={title} />
      <MetaTags>
        <meta name="og:title" content="Funny eCards - Send Custom Greeting Cards Online w/ JibJab!" />
        <meta
          name="og:description"
          content="Personalized eCards from JibJab for every occasion. Browse, customize, send funny greeting cards online for birthdays, holidays, valentines, thank yous & more!"
        />
      </MetaTags>
    </>
  );
};

AccountLayout.propTypes = {
  children: PropTypes.node,
  backLink: PropTypes.string,
  title: PropTypes.string,
};

export default AccountLayout;
